import { IntegrationTypeConfiguration } from "../types";
import ArrayConfigurationField from "./ArrayConfigurationField";
import StringConfigurationField from "./StringConfigurationField";
import { KeyValuePair } from "./utils/configFormatConverter";

interface ConfigurationFieldsProps {
  configurations: IntegrationTypeConfiguration[];
  values: Record<string, any>;
  onChange: (name: string, value: any) => void;
  errors?: Record<string, string>;
  disabled?: boolean;
}

const ConfigurationFields = ({
  configurations,
  values,
  onChange,
  errors = {},
  disabled = false,
}: ConfigurationFieldsProps) => {
  if (!configurations || configurations.length === 0) {
    return <p className="text-sm text-gray-500">No configuration required</p>;
  }

  return (
    <>
      {configurations.map((config) => {
        if (config.type === "array") {
          return (
            <ArrayConfigurationField
              key={config.name}
              config={config}
              value={values[config.name] || []}
              onChange={(value: KeyValuePair[]) => onChange(config.name, value)}
              disabled={disabled}
              error={errors[config.name]}
            />
          );
        } else {
          return (
            <StringConfigurationField
              key={config.name}
              config={config}
              value={values[config.name] || ""}
              onChange={(value: string) => onChange(config.name, value)}
              disabled={disabled}
              error={errors[config.name]}
            />
          );
        }
      })}
    </>
  );
};

export default ConfigurationFields;

